/* ============================================
   LEDME.RO — Theme JavaScript
   ============================================ */

document.addEventListener('DOMContentLoaded', function() {

  /* === Mobile Menu Toggle === */
  const navToggle = document.querySelector('.nav__toggle');
  const navInner = document.querySelector('.nav__inner');
  if (navToggle && navInner) {
    navToggle.addEventListener('click', function() {
      navInner.classList.toggle('open');
      this.textContent = navInner.classList.contains('open') ? '✕' : '☰';
    });
  }

  /* === Category Dropdowns === */
  document.querySelectorAll('.nav__link[data-mega]').forEach(function(link) {
    link.addEventListener('click', function(e) {
      e.preventDefault();
      const megaId = this.dataset.mega;
      const mega = document.getElementById(megaId);
      const allMegas = document.querySelectorAll('.nav__mega');
      const allLinks = document.querySelectorAll('.nav__link[data-mega]');

      allMegas.forEach(function(m) {
        if (m !== mega) m.style.display = 'none';
      });
      allLinks.forEach(function(l) {
        if (l !== link) l.classList.remove('active');
      });

      if (mega.style.display === 'block') {
        mega.style.display = 'none';
        this.classList.remove('active');
      } else {
        mega.style.display = 'block';
        this.classList.add('active');
      }
    });
  });

  /* Close mega menus when clicking outside */
  document.addEventListener('click', function(e) {
    if (!e.target.closest('.nav')) {
      document.querySelectorAll('.nav__mega').forEach(function(m) {
        m.style.display = 'none';
      });
      document.querySelectorAll('.nav__link').forEach(function(l) {
        l.classList.remove('active');
      });
    }
  });

  /* === Hero Slideshow === */
  const heroSlides = document.querySelectorAll('.hero__slide');
  const heroDots = document.querySelectorAll('.hero__dot');
  let currentSlide = 0;
  let slideInterval;

  function showSlide(index) {
    heroSlides.forEach(function(slide, i) {
      slide.style.display = i === index ? 'flex' : 'none';
      slide.style.animation = i === index ? 'fadeIn 0.6s ease' : 'none';
    });
    heroDots.forEach(function(dot, i) {
      dot.classList.toggle('active', i === index);
    });
    currentSlide = index;
  }

  function nextSlide() {
    showSlide((currentSlide + 1) % heroSlides.length);
  }

  if (heroSlides.length > 1) {
    slideInterval = setInterval(nextSlide, 5000);
    heroDots.forEach(function(dot, i) {
      dot.addEventListener('click', function() {
        clearInterval(slideInterval);
        showSlide(i);
        slideInterval = setInterval(nextSlide, 5000);
      });
    });
    showSlide(0);
  }

  /* === Product Image Gallery — Mini Thumbnails === */
  var mainImage = document.querySelector('.product-page__main-image img');
  var miniThumbs = document.querySelectorAll('.product-page__mini-thumb');

  miniThumbs.forEach(function(thumb) {
    thumb.addEventListener('click', function() {
      var newSrc = this.dataset.src;
      if (mainImage && newSrc) {
        mainImage.style.opacity = '0';
        setTimeout(function() {
          mainImage.src = newSrc;
          mainImage.style.opacity = '1';
        }, 150);
        miniThumbs.forEach(function(t) { t.classList.remove('active'); });
        this.classList.add('active');
      }
    });
  });

  /* Swipe support for product images on mobile */
  var galleryEl = document.querySelector('.product-page__main-image');
  if (galleryEl && miniThumbs.length > 1) {
    var touchStartX = 0;
    var currentThumb = 0;
    galleryEl.addEventListener('touchstart', function(e) { touchStartX = e.touches[0].clientX; }, { passive: true });
    galleryEl.addEventListener('touchend', function(e) {
      var diff = touchStartX - e.changedTouches[0].clientX;
      if (Math.abs(diff) > 50) {
        if (diff > 0 && currentThumb < miniThumbs.length - 1) currentThumb++;
        else if (diff < 0 && currentThumb > 0) currentThumb--;
        miniThumbs[currentThumb].click();
      }
    }, { passive: true });
  }

  /* Main image fade transition */
  if (mainImage) { mainImage.style.transition = 'opacity 0.15s ease'; }

  /* === Free Shipping Bar Animation === */
  var shippingFill = document.querySelector('.free-shipping-bar__fill');
  var shippingBar = document.getElementById('free-shipping-bar');
  if (shippingFill) {
    var targetWidth = shippingFill.dataset.target || shippingFill.style.width.replace('%','');
    shippingFill.style.width = '0%';
    setTimeout(function() {
      shippingFill.style.width = targetWidth + '%';
    }, 300);
    if (parseInt(targetWidth) >= 100 && shippingBar) {
      shippingBar.classList.add('free-shipping-bar--done');
    }
  }

  /* === Variant Selection (Product Page) === */
  document.querySelectorAll('.product-page__variant-btn').forEach(function(btn) {
    btn.addEventListener('click', function() {
      const group = this.closest('.product-page__variant-options');
      group.querySelectorAll('.product-page__variant-btn').forEach(function(b) {
        b.classList.remove('active');
      });
      this.classList.add('active');
    });
  });

  /* === Add to Cart AJAX === */
  const addToCartForms = document.querySelectorAll('form[action="/cart/add"]');
  addToCartForms.forEach(function(form) {
    form.addEventListener('submit', function(e) {
      e.preventDefault();
      const formData = new FormData(this);

      fetch('/cart/add.js', {
        method: 'POST',
        body: formData
      })
      .then(function(response) { return response.json(); })
      .then(function(data) {
        // Update cart count in header
        updateCartCount();
        // Show success feedback
        showNotification('Produs adăugat în coș!');
      })
      .catch(function(error) {
        console.error('Error:', error);
        showNotification('Eroare la adăugare.', 'error');
      });
    });
  });

  function updateCartCount() {
    fetch('/cart.js')
      .then(function(r) { return r.json(); })
      .then(function(cart) {
        var badges = document.querySelectorAll('.cart-badge');
        badges.forEach(function(el) {
          el.textContent = cart.item_count;
          el.style.display = cart.item_count > 0 ? 'flex' : 'none';
          el.classList.remove('pop'); void el.offsetWidth; el.classList.add('pop');
        });
      });
  }

  function showNotification(message, type) {
    type = type || 'success';
    var notif = document.createElement('div');
    notif.style.cssText = 'position:fixed;top:80px;right:20px;padding:14px 24px;border-radius:8px;color:white;font-weight:700;font-size:14px;z-index:9999;animation:fadeInUp 0.3s ease;box-shadow:0 4px 16px rgba(0,0,0,0.15);';
    notif.style.background = type === 'success' ? '#00A651' : '#e53935';
    notif.textContent = message;
    document.body.appendChild(notif);
    setTimeout(function() {
      notif.style.opacity = '0';
      notif.style.transition = 'opacity 0.3s';
      setTimeout(function() { notif.remove(); }, 300);
    }, 2500);
  }

  /* === Newsletter Form === */
  var newsletterForm = document.querySelector('.newsletter__form');
  if (newsletterForm) {
    newsletterForm.addEventListener('submit', function(e) {
      e.preventDefault();
      showNotification('Te-ai abonat cu succes!');
      this.reset();
    });
  }

  /* === Smooth scroll to anchor links === */
  document.querySelectorAll('a[href^="#"]').forEach(function(link) {
    link.addEventListener('click', function(e) {
      var target = document.querySelector(this.getAttribute('href'));
      if (target) {
        e.preventDefault();
        target.scrollIntoView({ behavior: 'smooth' });
      }
    });
  });

});

  /* === Wishlist (localStorage) === */
  window.toggleWishlist = function(btn) {
    var handle = btn.dataset.handle;
    var title = btn.dataset.title;
    try {
      var wishlist = JSON.parse(localStorage.getItem('ledme_wishlist') || '[]');
      var index = wishlist.indexOf(handle);
      if (index > -1) {
        wishlist.splice(index, 1);
        btn.classList.remove('active');
        showNotification(title + ' eliminat din favorite', 'error');
      } else {
        wishlist.push(handle);
        btn.classList.add('active');
        showNotification(title + ' adăugat la favorite');
      }
      localStorage.setItem('ledme_wishlist', JSON.stringify(wishlist));
      document.querySelectorAll('[data-handle="' + handle + '"]').forEach(function(b) {
        if (index > -1) b.classList.remove('active'); else b.classList.add('active');
      });
    } catch(e) {}
  };

  // Init wishlist on page load
  try {
    var wl = JSON.parse(localStorage.getItem('ledme_wishlist') || '[]');
    wl.forEach(function(h) {
      document.querySelectorAll('[data-handle="' + h + '"]').forEach(function(b) { b.classList.add('active'); });
    });
  } catch(e) {}

  /* === Notify Back in Stock Modal === */
  var nhtml = '<div class="notify-modal" id="notify-modal"><div class="notify-modal__box">'
    + '<div style="font-size:36px;margin-bottom:12px;">🔔</div>'
    + '<div class="notify-modal__title">Anunță-mă când revine</div>'
    + '<div class="notify-modal__product" id="notify-product-name"></div>'
    + '<input type="email" class="notify-modal__input" id="notify-email" placeholder="Adresa ta de email" required>'
    + '<input type="hidden" id="notify-handle">'
    + '<button type="button" class="notify-modal__submit" onclick="submitNotify()">Trimite</button>'
    + '<br><button type="button" class="notify-modal__close" onclick="closeNotifyModal()">Închide</button>'
    + '</div></div>';
  if (!document.getElementById('notify-modal')) {
    var nd = document.createElement('div'); nd.innerHTML = nhtml; document.body.appendChild(nd.firstChild);
  }

  window.openNotifyModal = function(t, h) {
    document.getElementById('notify-product-name').textContent = t;
    document.getElementById('notify-handle').value = h;
    document.getElementById('notify-email').value = '';
    document.getElementById('notify-modal').classList.add('open');
  };
  window.closeNotifyModal = function() { document.getElementById('notify-modal').classList.remove('open'); };
  window.submitNotify = function() {
    var e = document.getElementById('notify-email').value;
    if (!e || !e.includes('@')) { document.getElementById('notify-email').style.borderColor = '#e53935'; return; }
    try {
      var n = JSON.parse(localStorage.getItem('ledme_notify') || '[]');
      n.push({ email: e, handle: document.getElementById('notify-handle').value, date: new Date().toISOString() });
      localStorage.setItem('ledme_notify', JSON.stringify(n));
    } catch(x) {}
    closeNotifyModal();
    showNotification('Te vom anunța când produsul revine în stoc!');
  };
  var nm = document.getElementById('notify-modal');
  if (nm) { nm.addEventListener('click', function(e) { if (e.target === this) closeNotifyModal(); }); }

  /* === Auto-wrap iframes in product description for responsive === */
  document.querySelectorAll('.product-page__specs iframe, .product-page__info iframe').forEach(function(iframe) {
    if (!iframe.parentElement.classList.contains('video-wrapper')) {
      var wrapper = document.createElement('div');
      wrapper.className = 'video-wrapper';
      iframe.parentNode.insertBefore(wrapper, iframe);
      wrapper.appendChild(iframe);
      iframe.removeAttribute('width');
      iframe.removeAttribute('height');
    }
  });

  /* === Predictive Search (matches first words of product title) === */
  var searchInput = document.getElementById('search-input');
  var searchResults = document.getElementById('search-results');
  var searchTimeout;

  if (searchInput && searchResults) {
    searchInput.addEventListener('input', function() {
      clearTimeout(searchTimeout);
      var query = this.value.trim();
      if (query.length < 2) { searchResults.style.display = 'none'; return; }
      searchTimeout = setTimeout(function() {
        fetch('/search/suggest.json?q=' + encodeURIComponent(query) + '&resources[type]=product&resources[limit]=6')
          .then(function(r) { return r.json(); })
          .then(function(data) {
            var products = data.resources.results.products || [];
            if (products.length === 0) {
              searchResults.innerHTML = '<div class="search-results__empty">Nu s-au găsit produse pentru "' + query + '"</div>';
              searchResults.style.display = 'block';
              return;
            }
            var html = '';
            products.forEach(function(p) {
              var img = p.image ? '<img class="search-results__img" src="' + p.image + '" alt="" loading="lazy">' : '';
              html += '<a href="' + p.url + '" class="search-results__item">'
                + img
                + '<div class="search-results__info">'
                + '<div class="search-results__name">' + p.title + '</div>'
                + '<div class="search-results__price">' + (p.price ? p.price : '') + '</div>'
                + '</div></a>';
            });
            html += '<a href="/search?type=product&q=' + encodeURIComponent(query) + '" class="search-results__all">Vezi toate rezultatele →</a>';
            searchResults.innerHTML = html;
            searchResults.style.display = 'block';
          })
          .catch(function() { searchResults.style.display = 'none'; });
      }, 300);
    });

    // Close on click outside
    document.addEventListener('click', function(e) {
      if (!e.target.closest('.header__search')) {
        searchResults.style.display = 'none';
      }
    });

    // Close on Escape
    searchInput.addEventListener('keydown', function(e) {
      if (e.key === 'Escape') searchResults.style.display = 'none';
    });

    // Show results on focus if there's text
    searchInput.addEventListener('focus', function() {
      if (this.value.trim().length >= 2 && searchResults.innerHTML !== '') {
        searchResults.style.display = 'block';
      }
    });
  }
